import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import * as CheckoutActions from '@modules/checkout/CheckoutActions';

import LoginComponent from './LoginComponent';

const getActions = (checkout, userLogin, dispatch) => {
    const checkoutActions = Object.entries(CheckoutActions).reduce((actions, [name, action]) => {
        const newActions = { ...actions };

        newActions[name] = (...args) => dispatch(action(...args));

        return newActions;
    }, {});

    return {
        ...checkoutActions,
        ...(!checkout && userLogin && { forgotPassword: userLogin.forgotPassword })
    };
};

const LoginContainer = ({ checkout, social, enterprise, userLogin }) => {
    const dispatch = useDispatch();

    const checkoutActions = React.useMemo(
        () => getActions(checkout, userLogin, dispatch),
        [checkout, userLogin, dispatch]
    );

    return <LoginComponent checkout={checkout} social={social} enterprise={enterprise} actions={checkoutActions} />;
};

LoginContainer.propTypes = {
    checkout: PropTypes.number,
    social: PropTypes.number,
    enterprise: PropTypes.number,
    userLogin: PropTypes.shape({
        forgotPassword: PropTypes.func.isRequired
    })
};

LoginContainer.defaultProps = {
    checkout: 0,
    enterprise: 0,
    social: 0,
    userLogin: null
};

export default LoginContainer;
